import React from "react";
import icons from "../../../../../assets/images/icons";
import styles from "./MessageList.module.scss";

/**
 * Control/Checkbox (Figma 40003008:120685) - 네모 체크박스
 */
function Checkbox({ checked = false, onChange, className = "" }) {
  return (
    <div className={`${styles.checkboxWrap} ${className}`.trim()} data-name="Control/Checkbox">
      <div
        className={`${styles.checkbox} ${checked ? styles.checked : ""}`.trim()}
        onClick={(e) => {
          e.stopPropagation();
          onChange?.(!checked);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.stopPropagation();
            onChange?.(!checked);
          }
        }}
        role="checkbox"
        aria-checked={checked}
        tabIndex={0}
      >
        {checked && icons.messager?.check ? (
          <img
            src={icons.messager.check}
            alt=""
            className={styles.checkboxCheckImg}
            width={16}
            height={16}
            aria-hidden
          />
        ) : (
          <div className={styles.checkboxCheck} />
        )}
      </div>
    </div>
  );
}

/**
 * 단일 메시지 미리보기 행 (Figma Message preview - node 40004290-201808)
 * - status: 'Default' | 'Edit' (Edit 시 체크박스 표시)
 * - image: true 시 48x48 이미지 썸네일 + "[사진]" 요약
 * - banaccount: true 시 "차단한 사용자" 뱃지 (내가 상대를 차단)
 * - banaccountByOther: true 시 "차단당한 사용자" 뱃지 (상대가 나를 차단). banaccount 우선.
 * - notification/unreadCount: 읽지 않음 배지
 */
function MessagePreview({
  name = "대표명",
  previewText = "물건있고요 입주일이 2월20일 입니다.",
  time = "오전 11:30",
  unreadCount = 0,
  avatarUrl = null,
  previewImageUrl = null,
  status = "Default",
  image = false,
  banaccount = false,
  banaccountByOther = false,
  notification = true,
  checked = false,
  onCheckChange,
  onClick,
}) {
  const isEdit = status === "Edit";
  const showImageThumb = image && previewImageUrl;
  const displayPreviewText = previewText;

  const rowContent = (
    <>
      {isEdit && <Checkbox checked={checked} onChange={onCheckChange} />}
      {showImageThumb ? (
        <div className={styles.previewImage}>
          <img src={previewImageUrl} alt="" className={styles.previewImageImg} />
        </div>
      ) : (
        <div className={styles.avatar}>
          {avatarUrl ? (
            <img src={avatarUrl} alt="" className={styles.avatarImg} />
          ) : (
            <img
              src={icons.messager?.person}
              alt=""
              className={styles.avatarPlaceholderImg}
              aria-hidden
            />
          )}
        </div>
      )}
      <div className={styles.body}>
        <div className={styles.bodyHeader}>
          <div className={styles.nameRow}>
            <span className={styles.name}>{name}</span>
            {banaccount ? (
              <span className={styles.blockedBadge} aria-label="차단한 사용자">
                <img
                  src={icons.messager?.banIcon}
                  alt=""
                  className={styles.blockedBadgeIcon}
                  aria-hidden
                />
                <span className={styles.blockedBadgeText}>차단한 사용자</span>
              </span>
            ) : banaccountByOther ? (
              <span className={styles.blockedBadge} aria-label="나를 차단한 사용자">
                <img
                  src={icons.messager?.banOthersIcon}
                  alt=""
                  className={styles.blockedBadgeIcon}
                  aria-hidden
                />
                <span className={styles.blockedBadgeText}>나를 차단한 사용자</span>
              </span>
            ) : null}
          </div>
          <div className={styles.meta}>
            <div className={styles.time}>{time}</div>
          </div>
        </div>
        <div className={styles.previewRow}>
          <div className={styles.previewText}>{displayPreviewText}</div>
          {notification && unreadCount > 0 && (
            <div className={styles.badge}>{unreadCount > 99 ? "99+" : unreadCount}</div>
          )}
        </div>
      </div>
    </>
  );

  return (
    <div
      className={styles.preview}
      data-name="Message preview"
      data-node-id={isEdit ? "40004311:86200" : undefined}
    >
      <div className={styles.previewInner}>
        <div
          className={styles.row}
          onClick={isEdit ? () => onCheckChange?.(!checked) : onClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key !== "Enter") return;
            if (isEdit) onCheckChange?.(!checked);
            else onClick?.(e);
          }}
        >
          {rowContent}
        </div>
      </div>
      <div className={styles.divider} />
    </div>
  );
}

export default MessagePreview;
export { Checkbox };
